// removed by extract-text-webpack-plugin
module.exports = {"Navbar":"MainMenu__Navbar--qVuqo","NavbarBrand":"MainMenu__NavbarBrand--2njkZ","NavLink":"MainMenu__NavLink--3sk0X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/MainMenu/MainMenu.scss
// module id = 443
// module chunks = 0